<button
  mat-flat-button
  [type]="type()"
  [disabled]="isProcessing() || disabled()"
  [attr.aria-label]="ariaLabel()"
  (click)="clickOutput.emit()"
  [class]="appliedClasses()"
>
  <div class="relative flex items-center justify-center">
    <span [class.invisible]="isProcessing()">
      @let icon = iconMetaData(); @if (icon) {
      <div class="flex items-center gap-2">
        @if (icon.isSvg ?? true) {
        <mat-icon [class.order-1]="icon.afterContent" [class]="icon.appliedClasses" [svgIcon]="icon.icon" />
        } @else {
        <mat-icon [class.order-1]="icon.afterContent" [class]="icon.appliedClasses"> {{ icon.icon }} </mat-icon>
        } @if (label()) {
        <span [class.order-0]="icon.afterContent"> {{ label() | transloco }} </span>
        }
      </div>
      } @else {
      {{ label() | transloco }}
      }
    </span>

    @if (isProcessing()) {
    <div class="absolute">
      <mat-progress-spinner mode="indeterminate" diameter="20" />
    </div>
    }
  </div>
</button>
